import { Tabs } from "antd";
import ProductsList from "./ProductsList";
import CustomProductsList from "./CustomProductsList";
import QcRequestsList from "./QcRequestsList";
import { useEffect, useState } from "react";
const OrderdetailTabs = ({
  orderDetails = [],
  vendorDetailsData = [],
  status,
  qcRequestData,
  qcData,
  totalPrepTime,
  orderDeliveryType,
}) => {
  const [itemList, setItemList] = useState([]);

  useEffect(() => {
     setItemList(vendorDetailsData);
  }, [orderDetails, vendorDetailsData]);

  return (
    <>
      <div className="px-9 py-5 flex justify-between border-gray-250 border-b w-full">
        <div className="relative w-full tab-nav-transparent">
          <Tabs defaultActiveKey="1" className="bg-transparent">
            <Tabs.TabPane tab={<>Products</>} key={1}>
              {vendorDetailsData.vendorId > 0 ? itemList?.map((item, index) => {
                return (
                  <div className="" key={index}>
                    <h2 className="text-base font-semibold ">
                      {item?.vendorName}
                    </h2>
                    <div className="">
                      {item?.orderDetails?.map((itm, index) => {
                        if (itm?.type === "product") {
                          return (
                            <ProductsList
                              order={itm}
                              qcRequestData={qcRequestData}
                              status={status}
                              orderDeliveryType={orderDeliveryType}
                            />
                          );
                        } else {
                          return (
                            <CustomProductsList
                              order={itm}
                              index={index}
                              qcRequestData={qcRequestData}
                              status={status}
                              orderDeliveryType={orderDeliveryType}
                              isGuest={false}
                            />
                          );
                        }
                      })}
                    </div>
                  </div>
                );
              }) :  
              <div className="">
                {orderDetails?.map((itm, index) => {
                  if (itm?.type === "product") {
                    return (
                      <ProductsList
                        order={itm}
                        qcRequestData={qcRequestData}
                        status={status}
                        orderDeliveryType={orderDeliveryType}
                      />
                    );
                  } else {
                    return (
                      <CustomProductsList
                        order={itm}
                        index={index}
                        qcRequestData={qcRequestData}
                        status={status}
                        orderDeliveryType={orderDeliveryType}
                        isGuest={true}
                      />
                    );
                  }
                })}
              </div>}
            </Tabs.TabPane>
            {qcRequestData.length > 0 ? (
              <Tabs.TabPane tab={<>QC Requests</>} key={2}>
                <QcRequestsList
                  qcRequestData={qcRequestData}
                  orderDetails={orderDetails}
                  qcData={qcData}
                />
              </Tabs.TabPane>
            ) : null}
          </Tabs>
          <div className="absolute top-0 right-0 bg-[#cccccc] py-1 px-3 rounded-sm whitespace-nowrap">
            Estimated prep time {totalPrepTime} min
          </div>
        </div>
      </div>
    </>
  );
};
export default OrderdetailTabs;
